module.exports = __webpack_public_path__ + "img/back.dc0615bc.svg";